export default __webpack_public_path__ + "static/media/who_is_for_business_icon.fe8eaeb0.svg";